import React from 'react'
import styled from 'styled-components'

import PaletteProvider from 'contexts/PaletteProvider'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'

const Root = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.palette.neutral.eight};

  @media print {
    display: none;
  }
`

function InverseColourBanner({ children }: React.PropsWithChildren) {
  return (
    <PaletteProvider type="inverse">
      <Root>
        <LayoutContainer>
          {children}
        </LayoutContainer>
      </Root>
    </PaletteProvider>
  )
}

export default InverseColourBanner
